import { RightOutlined } from "@ant-design/icons";
import { twMerge } from "tailwind-merge";

export function TreeSwitcherIcon({
  expanded,
  isLeaf,
}: {
  expanded?: boolean;
  isLeaf?: boolean;
}) {
  if (isLeaf) {
    return null;
  }

  return (
    <RightOutlined
      className={twMerge(
        "text-xs transition-transform",
        expanded && "rotate-90",
      )}
    />
  );
}
